function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.01,
  fill: "#fff",
  d: "M0 .316h20v20H0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.25 10.316a8.75 8.75 0 1117.501.001 8.75 8.75 0 01-17.501-.001zm11.639 3.451l.558-.762a.154.154 0 00-.035-.216l-2.785-2.014V5.94a.157.157 0 00-.156-.156h-.94a.157.157 0 00-.156.156v5.377c0 .05.023.098.064.127l3.23 2.355c.071.051.169.037.22-.033z",
  fill: "#fff"
});

var SvgTime2 = function SvgTime2(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect opacity='0.01' y='0.315918' width='20' height='20' fill='white'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.25 10.3159C1.25 5.48389 5.16797 1.56592 10 1.56592C14.832 1.56592 18.75 5.48389 18.75 10.3159C18.75 15.1479 14.832 19.0659 10 19.0659C5.16797 19.0659 1.25 15.1479 1.25 10.3159ZM12.8887 13.7671L13.4473 13.0054C13.498 12.9351 13.4824 12.8374 13.4121 12.7886L10.627 10.7749V5.94092C10.627 5.85498 10.5566 5.78467 10.4707 5.78467H9.53125C9.44531 5.78467 9.375 5.85498 9.375 5.94092V11.3179C9.375 11.3687 9.39844 11.4155 9.43945 11.4448L12.6699 13.8003C12.7402 13.8511 12.8379 13.8374 12.8887 13.7671Z' fill='white'/%3E %3C/svg%3E";
export { SvgTime2 as ReactComponent };